// src/components/companion/SofiaAvatar.jsx
//
// Sofia's mark. Nigel is painting it — a morning star over the cloud deck —
// and it will land at /images/characters/sofia.webp. Until it does (and on any
// slow connection forever after), the fallback is an initial "S" in bright
// gold on a gunmetal disc, so the page never shows a broken-image glyph.
import React, { useState } from 'react';

const SofiaAvatar = ({ size = 40, className = '' }) => {
  const [failed, setFailed] = useState(false);
  const px = { width: size, height: size };

  if (failed) {
    return (
      <div
        style={px}
        className={`rounded-full bg-gunmetal border border-bright-gold/40 flex items-center justify-center flex-shrink-0 ${className}`}
        aria-hidden="true"
      >
        <span
          className="font-serif text-bright-gold font-semibold"
          style={{ fontSize: size * 0.5, lineHeight: 1 }}
        >
          S
        </span>
      </div>
    );
  }

  return (
    <img
      src="/images/characters/sofia.webp"
      alt=""
      style={px}
      className={`rounded-full object-cover flex-shrink-0 border border-bright-gold/40 ${className}`}
      onError={() => setFailed(true)}
      aria-hidden="true"
    />
  );
};

export default SofiaAvatar;
